// extracted by mini-css-extract-plugin
export var completionBody = "_le-2";
export var completionCard = "_le-0";
export var completionFooter = "_le-3";
export var completionTitle = "_le-1";